import { useTheme } from "@emotion/react";
import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CenteredText from "components/CenteredText";
import Page from "components/Page";
import ReactPlayerYT from 'react-player/youtube'

import ICLogo from "assets/images/ic_logo.svg"
import { Link } from "react-router-dom";

const DemoCenter = () => {
    const theme = useTheme();

    return (
        <Page bg={theme.palette.background.paper} syncNavCommand="IC_SLIDE" audioFile="/sounds/intro_ic.mp3">
            <Stack spacing={2} sx={{
                display: 'flex',
                flex: 1
            }}>
                <CenteredText>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginTop: '1rem' }}>
                        <img src={ICLogo} alt="Innovation Center Logo" style={{ width: '90%' }} />
                    </Box>
                </CenteredText>
                <CenteredText>
                    <Typography variant="h5" sx={{ paddingInline: '1.1rem', lineHeight: '2rem', fontWeight: 'bold' }}>
                        Cos’è Innovation Experience
                    </Typography>
                </CenteredText>
                <Box><Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>
                    Uno spazio fisico riconoscibile, presidiato e dedicato alle <b>attività di innovazione</b>,
                    al<b> 31 piano del Grattacielo Intesa Sanpaolo</b>, sede di <b>Intesa Sanpaolo Innovation Center</b>,
                    la società del Gruppo dedicata alla frontiera dell’innovazione.
                </Typography></Box>
                <Box>
                    <ReactPlayerYT
                        controls={true}
                        url='https://www.youtube.com/watch?v=lB9gqtINPzM'
                        width='100vw' height='17rem' />
                </Box>
                <Box>
                    <Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>
                        La società esplora <b>scenari e tendenze future</b>, sviluppa <b> progetti di ricerca applicata</b>,
                        supporta startup ad alto potenziale e accelera la trasformazione delle
                        imprese secondo i criteri <b>dell’open innovation e dell’economia circolare</b>,
                        per fare di Intesa Sanpaolo la forza trainante di un’economia più <b>consapevole,
                                inclusiva e sostenibile</b>.
                    </Typography>
                </Box>
                <Box>
                    <ReactPlayerYT
                        controls={true}
                        url='https://www.youtube.com/watch?v=7L75myLfxu8'
                        width='100vw' height='17rem' />
                </Box>
                <Box>
                    <Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>
                        Con un network nazionale e internazionale di hub e laboratori, l’Innovation Center è un
                        abilitatore di relazioni con gli altri stakeholder dell’ecosistema dell’innovazione
                        – come imprese tech, startup, incubatori, centri di ricerca e università – e
                        un promotore di nuove forme d’imprenditorialità nell’accesso ai capitali di rischio.
                    </Typography>
                </Box>
                <CenteredText style={{ marginBottom: '2rem' }}>
                    <Link to="/scopri_ic">
                        <Typography variant="h6"
                            color={theme.palette.white.main}
                            sx={{ textDecoration: 'underline' }}>
                            Torna a “Scopri Innovation Experience”
                        </Typography>
                    </Link>
                </CenteredText>
            </Stack>
        </Page >
    )
}

export default DemoCenter